// extracted by mini-css-extract-plugin
module.exports = {"features":"styles_features__3NekB","feature":"styles_feature__20hm0","illustration":"styles_illustration__3GBpu"};